import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// @ts-ignore
import { ConnectionStatus, Network } from '@capacitor/network';
import { StatusBarService } from '@core/services/status-bar.service';

@Injectable({
    providedIn: 'root',
})
export class NetworkService {
    public networkStatusChange$ = new BehaviorSubject<boolean>(true);
    public firstInit$ = new BehaviorSubject<boolean>(true);
    public previsionState$ = new BehaviorSubject<boolean>(true);

    constructor(private statusBarService: StatusBarService) {}

    public init() {
        Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
            this.networkStatusChange$.next(status.connected);
            this.firstInit$.next(false);
            this.previsionState$.next(status.connected);
        }).then();
    }

    public removeAllListeners() {
        Network.removeAllListeners().then();
    }
}
